import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDateFormat'
})
export class CustomDateFormatPipe implements PipeTransform {

  transform(value: Date | '-'): string {
    if (value === '-') {
      return '-';
    }
    if (value) {
      const day = this.pad(value.getDate());
      const month = this.pad(value.getMonth() + 1);
      const year = value.getFullYear().toString().substr(-2);
      const hour = this.pad(value.getHours());
      const minute = this.pad(value.getMinutes());

      return `${day}/${month}/${year} - ${hour}:${minute}`;
    }
    return null;
  }

  pad(number: number): string {
    return (number < 10) ? '0' + number : number.toString();
  }

}
